import { render, staticRenderFns } from "./ZhuanjiaCate.vue?vue&type=template&id=01c49ddf&scoped=true&"
import script from "./ZhuanjiaCate.vue?vue&type=script&lang=js&"
export * from "./ZhuanjiaCate.vue?vue&type=script&lang=js&"
import style0 from "./ZhuanjiaCate.vue?vue&type=style&index=0&id=01c49ddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c49ddf",
  null
  
)

export default component.exports